// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-modalheader_default__2vf7s","title":"idt-modalheader_title__1w6eu","close":"idt-modalheader_close__2okt8","closeIcon":"idt-modalheader_closeicon__3izti"};